import { render } from "./TestMoney.vue?vue&type=template&id=3d32a10e&scoped=true"
import script from "./TestMoney.vue?vue&type=script&lang=js"
export * from "./TestMoney.vue?vue&type=script&lang=js"

import "./TestMoney.vue?vue&type=style&index=0&id=3d32a10e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d32a10e"]])

export default __exports__